import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Fee } from '../domain/data';
import { FeeInterface } from '../../core';
import { Serializer } from '../client/helpers/serializer/serializer';

@Injectable({
    providedIn: 'root',
})
export class FeeResolver implements Resolve<FeeInterface> {
    constructor(private router: Router, private serializer: Serializer) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FeeInterface> {
        if (!this.router.getCurrentNavigation()?.extras.state.fee) {
            throw new Error('Fee not found');
        }

        return this.serializer.fromJson(this.router.getCurrentNavigation()?.extras.state.fee, Fee);
    }
}
